import {
  DeviceControlDeviceClassType,
  DeviceControlExclusionsSection,
  DeviceControlRulesSection,
  DeviceControlStatus,
} from '@nirvana/shared/dtos/types/policies/common';
import { ComplexSelectionFormValue } from '../../../../../../ui/gzSelectableTableRowGroup/types';
import { Columns } from '../../../uiSettings/deviceControl/helpers/ruleContainer/gridComponents/grid-config';

export interface DeviceControlRulesFormValue {
  uiSettings: { deviceControl: { dataLossPrevention: DeviceControlRulesSection } };
}
export interface DeviceControlExclusionsFormValue {
  uiSettings: { deviceControl: { dataLossPreventionExceptions: DeviceControlExclusionsSection } };
}
export enum DeviceControlRulesSearchableKeywords {
  DeviceControl = 'DeviceControl',
  Bluetooth = 'Bluetooth',
  CDROMDrive = 'CDROMDrive',
  FloppyDiskDrive = 'FloppyDiskDrive',
  IEEE1284_4 = 'IEEE1284_4',
  IEEE1394 = 'IEEE1394',
  Imaging = 'Imaging',
  Modem = 'Modem',
  TapeDrive = 'TapeDrive',
  WindowsPortable = 'WindowsPortable',
  COMLPTPorts = 'COMLPTPorts',
  SCSIRaid = 'SCSIRaid',
  Printers = 'Printers',
  NetworkAdapter = 'NetworkAdapter',
  WirelessNetworkAdapter = 'WirelessNetworkAdapter',
  InternalStorage = 'InternalStorage',
  ExternalStorage = 'ExternalStorage',
}

export enum DeviceControlExclusionsSearchableKeywords {
  Exclusions = 'Exclusions',
}

export enum DeviceType {
  FIREWIRE = 'FIREWIRE',
  IDE = 'IDE',
  USB = 'USB',
  SCSI = 'SCSI',
  SD = 'SD',
  PCI = 'PCI',
  PCMCIA = 'PCMCIA',
  UNKNOWN = 'UNKNOWN',
  ISAPNP = 'ISAPNP',
}

export interface DeviceControlRuleForm {
  deviceClass: DeviceControlDeviceClassType;
  ruleName: string;
  generalPermissions: DeviceControlStatus;
  permissions: ComplexSelectionFormValue<DeviceType, Columns>;
}
